<div class="container">
  <header>
    <div class="row headerPadding">
      <div class="col-lg-3"></div>
      <div class="col-lg-1  col-md-4 col-sm-3 col-sm-12 text-center ">
        <a href="#/{{rootModel.language}}"> <img src="../../assets/genel/dpu-logo1.png" class="text-center" width="auto"
            height="60"> </a>
      </div>
      <div class="col-lg-3    col-sm-12 d-none d-sm-block d-sm-none d-md-block">
        <a href="#/{{rootModel.language}}"> <img src="../../assets/genel/headerLogo3.png" class="text-center"
            width="auto" height="60"> </a>

      </div>


      <div class="col-lg-2 text-center   col-md-12 col-sm-12 col-xs-12">
        <a href="#/{{rootModel.language}}"> <img src="../../../assets/genel/DLogo.png" width="auto" height="60"> </a>
      </div>

      <div class="col-lg-1">

      </div>

      <div class="col-lg-2 text-center  dilClass  col-sm-12 col-md-12">
        <br class="d-none d-lg-block d-xl-none d-none d-xl-block">
        <div class="kutu text-center">
          <a class="" style="margin-right: 20px; text-decoration: none;" (click)="dilTr()" routerLink="/tr">
            <div class="tr"></div>
            <div style="color: rgb(216, 27, 27); margin-left: 3px;"> TR</div>
          </a>

        </div>

        <div class="kutu text-center">
          <a style="text-decoration: none;" (click)="dilEn()" routerLink="/en">
            <div class="en"></div>
            <div style="color:rgb(27, 5, 151) ">ENG</div>
          </a>
        </div>

      </div>

    </div>
  </header>
</div>


<nav class="navbar navbar-dark   bg-dark navbar-expand-lg navbar-light bg-light navbarCustem " style="padding: 0;">
<!-- <nav class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar navbarCustem " style="padding: 0;"> -->

  <div class="container" style="background-color:#5b4a42;">
    <a class="navbar-brand 	d-block d-sm-none d-none d-sm-block d-md-none" href="#">{{"menu" | translate}}</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item " *ngFor="let menu of menus">

          <div *ngIf="menu.children.length == 0; then rootmenu else dropdownmenu "> </div>
          <ng-template #rootmenu>
            <div *ngIf="menu.content_type == elinkTypeEnum.pageContentLink; then internal else external "> </div>
            <ng-template #internal>
              <a class="nav-link {{actifLink(menu)}}"
                routerLink="/{{rootModel.language}}/pages/{{menu.external_link}}/{{strbosluk(menu.name)}}" tabindex="-1"
                aria-disabled="false">{{menu.name}} </a>
            </ng-template>
            <ng-template #external>
              <a class="nav-link {{actifLink(menu)}}" href="{{menu.external_link}}" tabindex="-1"
                aria-disabled="true">{{menu.name}} </a>
            </ng-template>
          </ng-template>

          <ng-template #dropdownmenu>
            <app-dropdown [menu]="menu" [rootModel]="rootModel"> </app-dropdown>

          </ng-template>

        </li>

        <li class="nav-item px-3">
          <a class="nav-link {{actifLinkArsiv()}} " routerLink="/{{rootModel.language }}/archive" tabindex="-1"
            aria-disabled="true"> {{"archive" | translate}} </a>
        </li>
      </ul>

    </div>


  </div>

</nav>
<div class="" [style.top.px]="top" name="arabar" [style.left.px]="left" id="arabar"
  style="height: 15px; background-color: #b9984d; padding: 1px;">

</div>




<router-outlet></router-outlet>


<footer class="bg-dark p4 mt-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-1 col-sm-1"> <a
          href="http://editorialgos.dpu.edu.tr/login/index/d32275f4-f952-4966-9dfb-8f5164c6f976"
          target="_blank"><img src="../../assets/genel/gos1.png" width="%40" height="auto"></a></div>
      <div class="col-lg-9 col-sm-1" style="color:#d0caca; margin-left: 20px; margin-top: 24px;">
        @{{"all-rights-reserved" | translate}}
      </div>
    </div>
  </div>
</footer>